import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgendaService } from '../../services/agenda.service';
import { MensajeAdvertencia, MensajeError, MensajeExito, abrirModalCargando, calcularTiempo, cerrarModalCargando, isDefinedAndNotEmpty, responseValidator } from '@cf-v5-workspace/utils';
import ResponseModel from '@cf-v5-workspace/utils/models/response.model';
import VisorAgendaModel from '../../models/visor-agenda.model';
import { DatosVisorAgendaModel } from '../../models/datos-visor-agenda.model';
import { ParticipantesAgendaModel } from '../../models/participantes-agenda.model';
import { CategoriasEstados } from '@cf-v5-workspace/enums';
import LogsEstadosModel from '../../models/logs-estados.model';
import CRMEstadosWorkFlowModel from '../../models/crm-estados-workflow.model';
import { CrmEstadosService } from '../../services/crm-estados.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { ConfiguracionHistorialCambioEstadoModel } from '../../models/configuracion-historial-cambio-estado.model';
import { SettingsVisorAgendaModel } from '../../models/settings-visor-agenda.model';
import AdjuntarArchivosModel from '../../models/adjuntar-archivos.model';

@Component({
	selector: 'yem-inicio',
	templateUrl: './inicio.component.html',
	styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

	colorEstado: string;
	descripcionEstado: string;
	infoCita: DatosVisorAgendaModel;
	correcto: boolean;
	notificacionTitulo: string;
	notificacionMensaje: string;
	participantes: Array<ParticipantesAgendaModel>;
	esCitaMedica: boolean;
	estadosSiguientes: CRMEstadosWorkFlowModel[];
	usuario: string;
	verBtnConfirmar: boolean = false;
	verBtnCancelar: boolean = false;
	verBtnReprogramar: boolean = false;
	idCita: number;
	configHistoricoEstado: ConfiguracionHistorialCambioEstadoModel;
	nombreEmpresa: string;
	enumCategorias = CategoriasEstados;
	categoriaAdjuntarArchivo:CategoriasEstados;
	adjuntarArchivo: AdjuntarArchivosModel;

	constructor(
		private activateRoute: ActivatedRoute,
		private agendaService: AgendaService,
		private crmEstadosService: CrmEstadosService,
		private sessionStorage: SessionStorageService
	) { }

	ngOnInit(): void {
		this.activateRoute.params.subscribe(
			(data) => {
				// se sacan los datos recibidos por url y se setean en las variables globales
				let datosDecifrados = atob(data.infoAgenda);
				let parametros = JSON.parse(datosDecifrados) as SettingsVisorAgendaModel;
				let idEmpresa = parametros.idEmpresa;
				this.idCita = parametros.idCita;
				this.usuario = parametros.usuario;
				this.agendaService.login(idEmpresa).subscribe(
					() => {
						this.obtenerInformacionCita(this.idCita);
					}
				);
			}
		);
	}

	/**
	 * Método que se encarga de inicializar los datos necesarios del componente
	 * @author Bvelez
	 */
	inicializarComponente() {
		if(isDefinedAndNotEmpty(this.infoCita)) {
			this.infoCita.fechaFinal = new Date(this.infoCita.fechaFinal);
			this.infoCita.fechaInicio = new Date(this.infoCita.fechaInicio);
			let minutos = Math.floor((this.infoCita.fechaFinal.getTime() - this.infoCita.fechaInicio.getTime()) / (1000 * 60));
			this.infoCita.duracion = calcularTiempo(minutos, 24).descripcion;
			this.esCitaMedica = this.infoCita.categoria == CategoriasEstados.HistoriaClinica;
			this.colorEstado = this.infoCita.colorEstadoCita;
			this.descripcionEstado = this.infoCita.desEstadoCita;
			
			this.correcto = true;	
			const adjArchivoTmp = new AdjuntarArchivosModel();
			this.categoriaAdjuntarArchivo = (this.infoCita.categoria == CategoriasEstados.HistoriaClinica ? CategoriasEstados.CitaMedica: 
				(this.infoCita.categoria == CategoriasEstados.HistoriaClinicaUrgencias? CategoriasEstados.Ingreso : 
					!isDefinedAndNotEmpty(this.infoCita.categoria) ? CategoriasEstados.Agenda :  this.infoCita.categoria));
			switch(this.categoriaAdjuntarArchivo) {
				case CategoriasEstados.CitaMedica:
				case CategoriasEstados.Ingreso:
				case CategoriasEstados.Pacientes:
				case CategoriasEstados.Furips:
					
					adjArchivoTmp.numero = parseInt(this.infoCita.consecutivoPrefijoAct.length > 0 ? this.infoCita.consecutivoPrefijoAct.split('-')[1] : this.infoCita.consecutivoPrefijoAct);
					break;
				default:
					adjArchivoTmp.texto = this.infoCita.consecutivoPrefijoAct?.length > 0 ? this.infoCita.consecutivoPrefijoAct : 'Agenda-' + this.infoCita.id;
					break;
			}
			this.adjuntarArchivo = adjArchivoTmp;
			const configTmp = new ConfiguracionHistorialCambioEstadoModel();
			configTmp.categoria = CategoriasEstados.Agenda;
			configTmp.idOrigen = this.infoCita.id;
			this.configHistoricoEstado = configTmp;
		}
	}

	/**
	 * Método que se encarga de obtener la informacion de la agenda
	 * @author Bvelez
	 */
	obtenerInformacionCita(idCita: number) {
		try {
			abrirModalCargando();
			this.agendaService.obtenerInformacionCita(idCita).subscribe(
				(response: ResponseModel<VisorAgendaModel>) => {
					cerrarModalCargando();
					if (response.esExitoso) {
						if (isDefinedAndNotEmpty(response.datos)) {
							this.infoCita = response.datos.datosVisor;
							this.participantes = response.datos.participantes;
							this.nombreEmpresa = response.datos.nombreEmpresa;
							this.inicializarComponente();
							this.obtenerEstadosSiguiente();
						}
					} else {
						this.armarMensajeErrorServidor();
					}
				}, error => {
					cerrarModalCargando();
					this.armarMensajeErrorServidor(error.status);
				}
			)
		} catch (error) {
			cerrarModalCargando();
			console.log('Error');
			this.armarMensajeErrorServidor();
		}
	}

	/**
	 * Método que se encarga de crear un mensaje predefinido de acuerdo al error presentado por el servidor o por la petición
	 * @author Bvelez
	 */
	armarMensajeErrorServidor(statusCode: number = 0) {
		this.correcto = false;
		let state = parseInt((statusCode / 100).toString());
		switch (state) {
			case 4:
				this.notificacionTitulo = 'Error '+ statusCode;
				this.notificacionMensaje = 'No se puede realizar una conexion con el servidor';
				break;
			case 5:
				this.notificacionTitulo = 'Error '+ statusCode;
				this.notificacionMensaje = 'El servidor no es capaz de realizar la solicitud';
				break;
			default:
				this.notificacionTitulo = 'Lo sentimos.';
				this.notificacionMensaje = 'No se logró obtener la informacion necesaria';
		}
	}
	/**
	 * Método que se encarga de validar si los botones de cambio de estado son validos y se puede visualizar
	 * @author Bvelez
	 */
	validarBtnsCambioEstado() {
		this.verBtnConfirmar = false;
		this.verBtnCancelar = false;
		this.verBtnReprogramar = false;
		if (isDefinedAndNotEmpty(this.estadosSiguientes)) {
			// Se valida si el id de estado a confirmar definido es el siguiente estado disponible
			if (isDefinedAndNotEmpty(this.estadosSiguientes.find(m => m.idEstado == this.infoCita.idEstadoConfirmar))) {
				this.verBtnConfirmar = true;
			}
			// Se valida si el id de estado a cancelar definido es el siguiente estado disponible
			if (isDefinedAndNotEmpty(this.estadosSiguientes.find(m => m.idEstado == this.infoCita.idEstadoCancelar))) {
				this.verBtnCancelar = true;
			}
			// Se valida si el id de estado a reprogramar definido es el siguiente estado disponible
			if (isDefinedAndNotEmpty(this.estadosSiguientes.find(m => m.idEstado == this.infoCita.idEstadoReprogramar))) {
				this.verBtnReprogramar = true;
			}
		}
	}
	/**
	 * Método que se encarga de traer los siguientes estados a los que puede ir el documento
	 * @author Bvelez
	 */
	obtenerEstadosSiguiente(): void {
		abrirModalCargando();
		if (isDefinedAndNotEmpty(this.infoCita)) {
			let obtener = this.crmEstadosService.obtenerEstadosSiguientes(this.infoCita.idWorkFlow, this.infoCita.idEstadoCita).subscribe(
				(response: ResponseModel<Array<CRMEstadosWorkFlowModel>>) => {
					cerrarModalCargando();
					if(responseValidator(response)) {
						if (response.datos?.length > 0) {
							this.estadosSiguientes = response.datos;
						}
						this.validarBtnsCambioEstado(); 
					}
					obtener.unsubscribe();
				}, error => {
					cerrarModalCargando();
					console.log('Error al obtener los siguientes estados', error, `${this.obtenerEstadosSiguiente.name}`)
				}
			)
		} else {
			cerrarModalCargando();
			MensajeAdvertencia('No se recibe el estado actual');
		}
		
	}
	/**
	 * Método que se encarga de mapear los datos del formulario a un modelo
	 * @author Bvelez
	 * @returns 
	 */
	mapearAmodelo(idEstadoCambio: number): LogsEstadosModel {
		const log = new LogsEstadosModel();
		log.id = this.infoCita.idLogEstado;
		log.idOrigen = this.idCita;
		log.idEstadoAnterior = this.infoCita.idEstadoCita;
		log.idEstado = idEstadoCambio;
		log.idMotivo = 0;
		log.categoria = CategoriasEstados.Agenda;
		log.fecha = new Date();
		log.fechaModificacion = new Date();
		log.usuario = this.usuario;
		log.usuarioModificacion = this.sessionStorage.obtenerInfoSesion().usuario;
		log.usuarioCreacion = this.sessionStorage.obtenerInfoSesion().usuario;
		log.observacionEstado = `Visor agenda. Cambio de estado a ${this.estadosSiguientes.find(m => m.idEstado == idEstadoCambio)?.descripcion}`;
		log.enviarCorreo = false;
		log.agregarAlerta = false;
		log.enviarSMSCliente = false;
		return log;
	}

	/**
	 * Método que se encarga de realizar el cambio de estado del documento
	 * @author Bvelez
	 */
	cambiarEstado(idEstadoCambio: number): void {
		abrirModalCargando();
		const datos = this.mapearAmodelo(idEstadoCambio);
		const infEstadoSiguiente = this.estadosSiguientes.find(m => m.idEstado == datos.idEstado);
		let agregar = this.crmEstadosService.agregarLogEstados({log: datos, infoEstadoSiguiente: infEstadoSiguiente}).subscribe(
			(response: ResponseModel<Array<LogsEstadosModel>>) => {
				cerrarModalCargando();
				if (response.esExitoso == true) {
					MensajeExito('Se cambió el estado correctamente');
					this.obtenerInformacionCita(this.idCita);
				} else {
					console.log(response);
					MensajeError('Problemas al cambiar el estado');
				}
				agregar.unsubscribe();
			}, error => {
				cerrarModalCargando();
				console.log('Problema en el cambio de estado', error, `${this.cambiarEstado.name}`);
				agregar.unsubscribe();
			}
		);
	}

}
